import Swiper, {Keyboard, Navigation, Pagination} from 'swiper';
Swiper.use([Keyboard, Navigation, Pagination]);

import barba from '@barba/core';

export default class ProductMediaCarousel {
	constructor(elm) {
		this.elm = elm;

		this.pagination = this.elm.querySelector('[data-swiper-pagination]');

        this.breakpoint = window.matchMedia('(max-width:991px)');
        this.breakpoint.addEventListener('change', () => {
            if(this.breakpoint.matches) {
                this.init();
            } else {
                if(this.swiper) {
                    this.swiper.destroy();
                }
            }
        });

        if(this.breakpoint.matches) {
            this.init();
        }
	}

	init() {
		this.swiper = new Swiper(this.elm, {
			init: false,
			threshold: 2,
			slideClass: 'swiper-slide',
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
            centeredSlides: true,
            //loop: true,
			grabCursor: true,
			touchEventsTarget: 'container',
			speed: 800,

			slidesPerView: 1,
			spaceBetween: 0,

			pagination: {
				el: this.pagination,
			},
		});

		this.swiper.on('slideChange', e => {
			const activeSlide = e.slides[e.activeIndex];

			const code = activeSlide.getAttribute('data-code');
			barba.logoLayerDirector.newCode(code);
		});

		this.swiper.on('resize', (e) => {
			this.swiper.update();
		});

		this.swiper.init();

	}
}